<template lang="pug">
#container
  #overlay
    input(type='text' name='username' v-model='username' placeholder='username')
    input(type='password' name='password' v-model='password' placeholder='password' v-on:keyup.enter="connectMe")
    input(type='submit' @click='connectMe')
    p.error {{error}}
</template>

<script>
import axios from 'axios'
// import connection from '@/components/admin/Connection'
let BACK_END_PATH = process.env.VUE_APP_BACK_END_PATH

export default {
  data() {
    return {
      password: '',
      username: '',
      error: '',
    }
  },
  methods: {
    async connectMe() {
      if (this.password.length <= 0 || this.username.length <= 0) {
        this.error = 'champs incomplet'
      } else {
        let data = JSON.stringify({
          username: this.username,
          password: this.password,
        })

        let url = `${BACK_END_PATH}/login`

        await axios({
          method: 'post',
          url,
          data,
        }).then(r => {
          // console.log(url)
          // console.log(r.data)
          if (r.data == 1) {
            this.$emit('connected')
          } else {
            this.error = r.data
          }
        })
      }
    },
  },
}
</script>

<style scoped>
#container {
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  height: 95vh;
}
#overlay {
  display: flex;
  flex-direction: column;
}
</style>
